import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './brand/theme.css';
import { applyBrand } from './brand/brand';
import { applyTenant } from './brand/tenant';
import { authBackground } from './brand/assets';
import App from './App';
import { Provider, useSelector } from 'react-redux';
import { createStore } from 'redux';
import auth from './store/user';
import { ErrorProvider } from './helpers/ErrorContext';

export const store = createStore(auth);

// ÐÑÐµÐ½Ð´ (DOSCAR / Horizon) Ð²ÑÐ±Ð¸ÑÐ°ÐµÑÑÑ Ð¿ÑÐ¸ ÑÐ±Ð¾ÑÐºÐµ ÑÐµÑÐµÐ· REACT_APP_BRAND:
// Ð°ÑÑÐ¸Ð±ÑÑ Ð´Ð»Ñ CSS-Ð¿ÐµÑÐµÐ¼ÐµÐ½Ð½ÑÑ, Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²Ð¾Ðº Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð¸ ÑÐ¾Ð½ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð²ÑÐ¾Ð´Ð°.
applyBrand();
// ÐÑÐ¾ÐºÐµÑ Ð¿Ð¾Ð²ÐµÑÑ Ð±ÑÐµÐ½Ð´Ð° (REACT_APP_TENANT): ÑÐ²Ð¾Ñ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¸ Ð¸ÐºÐ¾Ð½ÐºÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ¸.
applyTenant();
document.documentElement.style.setProperty('--brand-auth-bg', `url(${authBackground})`);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <ErrorProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorProvider>
  // </React.StrictMode>
);
